import { createContext, useState } from "react";

const StorefrontCartContext = createContext<{
  shopifyStorefrontCart: any;
  setShopifyStorefrontCart: (shopifyStorefrontCart: any) => void;
}>({
  shopifyStorefrontCart: undefined,
  setShopifyStorefrontCart: (shopifyStorefrontCart: any) => {},
});

const StorefrontCartContextProvider = ({ value = null, children }) => {
  const [shopifyStorefrontCart, setShopifyStorefrontCart] = useState(value);

  return (
    <StorefrontCartContext.Provider
      value={{
        shopifyStorefrontCart,
        setShopifyStorefrontCart,
      }}
    >
      {children}
    </StorefrontCartContext.Provider>
  );
};

export { StorefrontCartContext, StorefrontCartContextProvider };
